export const authenticationIsDisabled = () =>
  import.meta.env.VITE_ENV_DISABLE_AUTHENTICATION?.toLowerCase() === 'true';
